// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"style_searchIcon_1aV1R","removeIcon":"style_removeIcon_2V94Q","txtSearch":"style_txtSearch_3w-_j","divSearch":"style_divSearch_yH8PN"};